// A page that lists polls, members or saved locations hears when the
// assistant's confirmation card changed them, and reads its list again. The
// card writes from the chat panel, which sits over whatever page the coach is
// on; without this the page behind it kept showing the list as it loaded.

const EVENT_NAME = 'assistantDataChanged';

/** kind: 'polls' | 'members' | 'locations' */
export function emitAssistantDataChanged(kind) {
  try {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { kind } }));
  } catch {
    // Non-fatal: the change is saved; the page shows it on its next load.
  }
}

/** Calls `handler` when `kind` changes. Returns the unsubscribe. */
export function onAssistantDataChanged(kind, handler) {
  const listener = (event) => {
    if (event?.detail?.kind === kind) handler();
  };
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
}
